module.exports = __webpack_public_path__ + "img/check.d4b2cebe.svg";